<!--<p>tab-product-exclusive works!</p>-->
<div #noteWrapper *ngIf="isSubAreaChanges()">
  <app-note-view [color]="'info'" [icon]="STRING_CONSTANTS.ICON.IC_INFORMATION" [extraContent]="true">
    <div class="d-flex align-items-center justify-content-between">
      <span>Terdapat Produk Eksklusif yang dihapus karena perubahan Sub Area Distributor.</span>
      <button class="btn btn-primary py-2" type="button" (click)="onModalShowPEOpen()">Lihat Detail</button>
    </div>
  </app-note-view>

  <!--modal view deleted PE-->
  <app-modal #modalShowPE [modalConfig]="modalPEConfig" [modalOptions]="{ size: 'md' }">
    <ng-container *ngIf="isLoading | async; else contentTPL">
      <app-section-loader />
    </ng-container>
    <ng-template #contentTPL>
      <ng-container *ngIf="deletedPESubject | async as data">
        <ul class="mx-n4">
          <li *ngFor="let item of data.product_exclusive; first as first" [class.mt-4]="!first">
            <span>{{ item.title }}</span>
            <span class="text-gray-700 d-block">Dihapus pada: {{ renderEpochDate(item.deleted_date) }}</span>
          </li>
        </ul>
      </ng-container>
    </ng-template>
  </app-modal>
</div>

<!-- temp. use legacy detail component -->
<app-product-exclusive [distributorInfo]="distributorInfoSubject.value" />
